import React, {
    Component, createRef, 
    // useContext, 
    useState} from 'react';

import { Row } from 'react-bootstrap';

import FormInput from '../../Component/Utilities/FormInput/FormInput';
import PrimaryButton from '../../Component/Utilities/PrimaryButton/PrimaryButton';
// import NavigationContext from '../../Context/NavigationContext';

import './SubmitTicketPage.scss';
import transactionAPI from '../../Data/Transaction';
import bankAPI from '../../Data/Bank';

// import Init from '../../Init/Init';
import CustomToast from '../../Component/Utilities/Toast/Toast';

const TicketForm = ({ transactionCodeRef, complaintRef, resendRef, bankCodeRef, bankAccountNoRef, bankAccountNameRef, complaintProofRef, displayToast }) => {
    // const context = useContext(NavigationContext);
    // const { navigate } = context;

    const [ disableButton, setDisableButton ] = useState(true);
    const [ isResend, setIsResend ] = useState(1);

    const onChangeSearch = () => {
        let searchRef = transactionCodeRef.ref.current;
        let searchButtonDisabled = disableButton;

        if(searchRef.value !== '') {
            searchRef.classList.add('is-filled');
            searchButtonDisabled = false;
        } else {
            searchRef.classList.remove('is-filled');
            searchButtonDisabled = true;
        }

        if(searchButtonDisabled !== disableButton) {
            setDisableButton(searchButtonDisabled);
        }

        const resendValue = parseInt(resendRef.ref.current.value);
        // if( resendValue ) {
        //     bankCodeRef.ref.current.value = "";
        //     bankAccountNoRef.ref.current.value = "";
        //     bankAccountNameRef.ref.current.value = "";
        // }

        setIsResend(resendValue);
    };

    const submitTicket = async () => {
        const transactionCode = transactionCodeRef.ref.current.value;
        const complaint = complaintRef.ref.current.value;
        const resend = resendRef.ref.current.value;
        const complaintProof = complaintProofRef.ref.current ? complaintProofRef.ref.current.value : null;
        const bankCode = bankCodeRef.ref.current ? bankCodeRef.ref.current.value : "";
        const bankAccountNo = bankAccountNoRef.ref.current ? bankAccountNoRef.ref.current.value : "";
        const bankAccountName = bankAccountNameRef.ref.current ? bankAccountNameRef.ref.current.value : "";

        const requestData = {
            transactionCode,
            complaint,
            resend,
        };

        if( complaintProof !== null ) {
            requestData.complaintProof = complaintProof;
        }

        if( bankCode !== "" ) {
            requestData.bankCode = bankCode;
        }
        if( bankAccountNo !== "" ) {
            requestData.bankAccountNo = bankAccountNo;
        }
        if( bankAccountName !== "" ) {
            requestData.bankAccountName = bankAccountName;
        }

        const response = await transactionAPI.submitTicket(requestData);

        if( response.hasOwnProperty('errorCode') && response.errorCode === 0 ) {
            // Success toast, clear form
            displayToast({
                title: "Success",
                message: response.message,
                status: 1,
                show: 1,
            });
        } else {
            // Failed toast
            displayToast({
                title: "Failed",
                message: response.message,
                status: 1,
                show: 1,
            });
        }
    }

    return (
        <div className="submit-ticket-container">
            <h3 className="submit-ticket-title">
                Pengajuan Komplen
            </h3>
            <div className="submit-ticket-form">
                <Row>
                    <FormInput
                        name={'transaction_code'}
                        attribute={ transactionCodeRef }
                        onChange={ () => onChangeSearch() }
                    />
                    <FormInput
                        name={'complaint'}
                        attribute={ complaintRef }
                        onChange={ () => onChangeSearch() }
                    />
                    <FormInput
                        name={'resend'}
                        attribute={ resendRef }
                        options={ resendRef.options }
                        onChange={ () => onChangeSearch() }
                    />
                    {
                        !isResend ? (
                            <>
                                <FormInput
                                    name={'bank_code'}
                                    attribute={ bankCodeRef }
                                    options={ bankCodeRef.options }
                                    onChange={ () => onChangeSearch() }
                                />
                                <FormInput
                                    name={'bank_account_no'}
                                    attribute={ bankAccountNoRef }
                                    onChange={ () => onChangeSearch() }
                                />
                                <FormInput
                                    name={'bank_account_name'}
                                    attribute={ bankAccountNameRef }
                                    onChange={ () => onChangeSearch() }
                                />
                            </>
                        ) : ""
                    }
                    <FormInput
                        name={'complaint_proof'}
                        attribute={ complaintProofRef }
                        onChange={ () => onChangeSearch() }
                    />
                </Row>
            </div>
            <div className="submit-ticket-btn-container">
                <PrimaryButton disabled={ disableButton } customClass='submit-ticket-btn' size='sm' onClick={ () => submitTicket() }>
                    Submit
                </PrimaryButton>
            </div>
        </div>
    );
}

class SubmitTicketPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            transactionCode: {
                label: 'Kode Transaksi',
                ref: createRef(),
                placeholder: 'Cth: TX-0010291',
                width: 12,
                required: true,
                type: "text"
            },
            complaint: {
                label: 'Jelaskan Kendala Anda',
                ref: createRef(),
                placeholder: '',
                width: 12,
                required: true,
                type: "textarea"
            },
            resend: {
                label: 'Pilih Usulan Penyelesaiannya',
                ref: createRef(),
                placeholder: '',
                width: 6,
                required: true,
                type: "select",
                defaultValue: "1",
                options: [
                    { value: '1', label: 'Pengiriman Ulang' },
                    { value: '0', label: 'Refund Dana' },
                ]
            },
            // Display this if they re requesting for refund
            bankCode: {
                label: 'Pilih Bank Rekening Anda',
                ref: createRef(),
                placeholder: '',
                width: 12,
                required: true,
                type: "select",
                baseValue: "1",
                options: [
                    // Get bank codes from API
                ]
            },
            bankAccountName: {
                label: 'Nama Rekening Bank',
                ref: createRef(),
                placeholder: 'Isikan nama yang terdaftar di rekening bank anda',
                width: 6,
                required: false,
                type: "text"
            },
            bankAccountNo: {
                label: 'No. Rekening Bank',
                ref: createRef(),
                placeholder: 'Cth: 123456789',
                width: 6,
                required: false,
                type: "text"
            },
            // End of refund data
            complaintProof: {
                label: 'Upload Bukti',
                ref: createRef(),
                placeholder: "",
                width: 12,
                required: false,
                type: "file",
            },
            searchButtonDisabled: true,
            toast: {
                title: "",
                status: 0,
                show: 0,
                message: ""
            }
        }
    }

    componentDidMount() {
        window.addEventListener('resize', function(event){});
        const thisClass = this;
        const state = {...this.state};
        
        ( async () => {
            const response = await bankAPI.bankList();

            if( response.hasOwnProperty('errorCode') && response.errorCode === 0 ) {
                thisClass.setState({
                    ...state,
                    bankCode: {
                        ...state.bankCode,
                        options: [
                            {value: "", label: "--- Pilih Bank ---"},
                            ...response.data.map((item, index) => {
                                return {
                                    value: item.bank_short_name,
                                    label: `[${item.bank_short_name}] ${ item.bank_name }`
                                }
                            })
                        ]
                    }
                });
            }
        } )();
    }

    componentDidUpdate() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    
    componentWillUnmount() {
        this.setState = (state,callback)=>{
            return;
        };

        window.removeEventListener('resize', () => {});
    }

    displayToast(content) {
        this.setState({
            ...this.state,
            toast: {
                ...content
            }
        });
    }

    closeToast() {
        const state = {...this.state};
        const toast = state.toast;

        this.setState({
            ...state,
            toast: {
                ...toast,
                show: 0,
            }
        });
    }

    render() {
        return (
            <div className='submit-ticket-page'>
                <CustomToast 
                    title={this.state.toast.title}
                    status={this.state.toast.status}
                    show={this.state.toast.show}
                    onClose={() => this.closeToast()}
                >
                    { this.state.toast.message }
                </CustomToast>
                <TicketForm 
                    transactionCodeRef={this.state.transactionCode} 
                    complaintRef={this.state.complaint}
                    resendRef={this.state.resend}
                    complaintProofRef={this.state.complaintProof}
                    bankCodeRef={this.state.bankCode}
                    bankAccountNameRef={this.state.bankAccountName}
                    bankAccountNoRef={this.state.bankAccountNo}
                    displayToast={ (content) => this.displayToast(content) }
                />
            </div>
        );
    }
}

export default SubmitTicketPage;